
import React from 'react';
import { useParams } from 'react-router-dom';
import ContentPageTemplate from './ContentPageTemplate';
import { gameData } from './gameData';

const GameContentDynamic = () => {

  const { gameId } = useParams();
  const game = gameData[gameId];


  if (!game) return <div>Game not found</div>;

  return (
    <ContentPageTemplate
      title={game.title}
      image={game.image}
      description={game.description}
      buttons={game.buttons} />);


};

export default GameContentDynamic;